// ========================================
// services/inventoryService.ts
// ========================================

import apiClient from "../api/apiClient";

// ========================================
// TYPES
// ========================================

export interface InventoryApiResponse {
  productID: number;
  productName: string;
  sku: string;
  categoryName: string;
  stockQty: number;
  minStockQty: number;
  status: string;
  lastRestocked?: string | null;
}

// ========================================
// GET INVENTORY
// ========================================

export async function getInventoryItems() {
  const response = await apiClient.get<
    InventoryApiResponse[]
  >("/inventory");

  return response.data;
}

// ========================================
// RESTOCK INVENTORY
// ========================================

export async function restockInventoryItem(
  productId: string,
  quantity: number
) {
  const response = await apiClient.post(
    `/inventory/${productId}/restock`,
    {
      quantity,
    }
  );

  return response.data;
}